module.exports = __webpack_public_path__ + "img/image-eraser2.10f5b0aa.png";